import { useQuery } from "@tanstack/react-query"
import { useParams, useSearchParams } from "react-router-dom"
import { useTournamentLive } from "@/features/tournament/useTournamentLive"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getDailyTournamentDetail } from "@/api/dailyVirtualTournamentApi"
import { ColorRank } from "@/types/battle"
import { RANK_NAMES } from "@/constants/guardians"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"

export default function DailyTournamentDetailPage() {
  const { tournamentId } = useParams<{ tournamentId: string }>()
  const [params] = useSearchParams()
  const colorRank = (params.get("colorRank") ?? "WHITE") as ColorRank

  const queryKey = ["daily-t-detail", tournamentId] as const

  const q = useQuery({
    queryKey: [...queryKey],
    queryFn: () => getDailyTournamentDetail(tournamentId!),
    enabled: Boolean(tournamentId),
    refetchInterval: 30_000,
  })

  useTournamentLive(tournamentId, [...queryKey])

  const detail = q.data

  return (
    <GameScreenLayout
      title={detail?.title ?? "Ежедневный турнир"}
      backTo="/play/daily-tournament"
    >
      <p className="mb-3 text-xs text-guardians-muted">
        {RANK_NAMES[colorRank]} · {detail?.status ?? "…"}
      </p>
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : q.isError ? (
        <p className="text-sm text-red-300">
          {getGameApiErrorMessage(q.error, "Ошибка")}
        </p>
      ) : !detail ? (
        <p className="text-sm text-guardians-muted">Турнир не найден</p>
      ) : (
        <>
          <ul className="mb-4 space-y-1 text-sm">
            {detail.participants.map((p) => (
              <li key={p.id} className="flex justify-between">
                <span>{p.passport?.nickname ?? p.id}</span>
                <span className="text-guardians-muted">{p.status}</span>
              </li>
            ))}
          </ul>
          <ul className="space-y-2 text-xs">
            {detail.matches.map((m) => (
              <li
                key={m.id}
                className="rounded-lg border border-white/10 px-2 py-1"
              >
                Раунд {m.round} · {m.status}
              </li>
            ))}
          </ul>
        </>
      )}
    </GameScreenLayout>
  )
}
